<template>
  <div class="container">
    <h3 class="title is-3 has-text-centered">Welcome to ShareDocView</h3>
    <p class="has-text-centered has-text-grey has-margin-bottom-1">
      <em>
        Let's start sharing those important documents with your community!
      </em>
    </p>
    <div class="columns is-centered">
      <div class="column is-one-third">
        <div class="notification is-danger" v-if="generalError">
          {{ generalError }}
        </div>
        <div class="notification is-primary" v-if="success">{{ success }}</div>
        <form id="registerForm" @submit="submitForm($event)" novalidate v-if="!success">
          <div class="field">
            <label for="email" class="label">Email</label>
            <div class="control has-icons-left">
              <input
                v-model="newUser.email"
                id="email"
                required="required"
                placeholder="john.doe@example.com"
                name="email"
                class="input"
                :class="{ 'is-danger': !email.valid }"
                type="email"
              />
              <span class="icon is-small is-left">
                <i class="fas fa-envelope"></i>
              </span>
            </div>
            <p class="help" :class="{ 'is-danger': !email.valid }">
              {{ email.errorMessage }}
            </p>
          </div>
          <div class="field">
            <label class="label">Password</label>
            <div class="control has-icons-left">
              <input
                v-model="newUser.password"
                id="password"
                required="required"
                placeholder="Password"
                name="password"
                class="input"
                :class="{ 'is-danger': !password.valid }"
                type="password"
              />
              <span class="icon is-small is-left">
                <i class="fas fa-lock"></i>
              </span>
            </div>
            <p class="help" :class="{ 'is-danger': !password.valid }">
              {{ password.errorMessage }}
            </p>
          </div>
          <div class="field">
            <label class="label">Confirm Password</label>
            <div class="control has-icons-left">
              <input
                v-model="newUser.confirmPassword"
                id="confirmPassword"
                required="required"
                placeholder="Confirm password"
                name="confirmPassword"
                class="input"
                :class="{ 'is-danger': !confirmPassword.valid }"
                type="password"
              />
              <span class="icon is-small is-left">
                <i class="fas fa-lock"></i>
              </span>
            </div>
            <p class="help" :class="{ 'is-danger': !confirmPassword.valid }">
              {{ confirmPassword.errorMessage }}
            </p>
          </div>
          <div class="field">
            <button
              type="submit"
              class="button is-fullwidth is-primary text-capitalize"
            >
              Sign up
            </button>
          </div>
          <div class="is-divider" data-content="OR"></div>
          <div class="field">
            <a
              class="button button-linkedin is-fullwidth"
              :href="`/api/users/auth/linkedin${queries}`"
              @click="handleSocialSignUp"
            >
              <span class="icon">
                <i class="fab fa-linkedin"></i>
              </span>
              <span>Sign up with LinkedIn</span>
            </a>
          </div>
          <div class="field">
            <a
              class="button button-google is-fullwidth"
              :href="`/api/users/auth/google${queries}`"
              @click="handleSocialSignUp"
            >
              <span class="icon">
                <i class="fab fa-google"></i>
              </span>
              <span>Sign up with Google</span>
            </a>
          </div>
          <div
            class="is-divider"
            data-content="I already have an account"
          ></div>
          <div class="field">
            <router-link
              :to="`/${queries}`"
              class="button is-fullwidth is-success"
            >
              Take me to Log in
            </router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      newUser: {
        email: '',
        password: '',
        confirmPassword: ''
      },
      generalError: '',
      success: '',
      email: {
        valid: true,
        errorMessage: ''
      },
      password: {
        valid: true,
        errorMessage: ''
      },
      confirmPassword: {
        valid: true,
        errorMessage: ''
      }
    };
  },
  computed: {
    queries() {
      let params = [];
      if (this.$route.query?.from) {
        params.push(`returnTo=${this.$route.query.from}`);
      } else if (this.$route.query?.returnTo) {
        params.push(`returnTo=${this.$route.query.returnTo}`);
      }
      if (this.$route.query?.plan) {
        params.push(`plan=${this.$route.query.plan}`);
      }
      params = params.join('&');
      params = params.length ? '?' + params : '';
      return params;
    }
  },
  methods: {
    submitForm(evt) {
      evt.preventDefault();
      let form = this.$el.querySelector('#registerForm');
      let fields = [
        {
          field: this.$el.querySelector('#email'),
          validation: this.email
        },
        {
          field: this.$el.querySelector('#password'),
          validation: this.password
        },
        {
          field: this.$el.querySelector('#confirmPassword'),
          validation: this.confirmPassword
        }
      ];
      if (form.checkValidity()) {
        if (this.newUser.password !== this.newUser.confirmPassword) {
          this.generalError = 'The passwords do not match';
          return;
        }
        let body = {
          email: this.newUser.email,
          password: this.newUser.password,
          confirmPassword: this.newUser.confirmPassword,
          plan: this.$route.query.plan
        };
        this.$axios
          .post(this.$API.signUp, body)
          .then(response => {
            if (response.status === 200) {
              this.generalError = '';
              response.data.token = response.headers.auth;
              // Set the axios token
              this.$axios.defaults.headers.common['auth'] =
                response.headers.auth;
              this.$store.commit('auth/setUser', response.data);
              this.$store.commit('auth/setNavDisabled', true);
              console.log(response.data);
              if(response.data.account.planId.includes('free')){
                this.changeDisabled();
                this.$router.push('/dashboard');
              } else {
                this.$store.commit('auth/setNeedsCheckout', true);
                this.$router.push(`/profile/checkout?price=${response.data.account.planId}`);
                this.$store.commit('auth/setPreviousURL', `/profile/checkout?price=${response.data.account.planId}`);
              }
            }
          })
          .catch(e => (this.generalError = e.response.data.message));
      } else {
        fields.forEach(field => {
          field.validation.valid = field.field.checkValidity();
          field.validation.errorMessage = field.field.validationMessage;
        });
      }
    },
    changeDisabled() {
      this.$store.commit('auth/setNavDisabled', false);
    },
    completeCheckout() {
      this.$store.commit('auth/setNeedsCheckout', false);
    },
    handleSocialSignUp() {
      this.$store.commit('auth/setNavDisabled', true);
      this.$store.commit('auth/setNeedsCheckout', true);

      //User registers for a free plan
      if (!this.$route.query?.plan) {
        this.changeDisabled();
        this.completeCheckout();
      }
    }
  }
};
</script>
